import { useState } from 'react';

import { CheckIcon, EllipsisVerticalIcon, SettingsIcon, XIcon } from '@air/design-icons';
import { ActionSheet, ActionSheetHeader, renderActionSheetItems } from '@air/primitive-action-sheet';
import { IconButton } from '@air/primitive-icon-button';

export type MobileNotificationHeaderProps = {
  onClose?: () => void;
  onMarkAllAsRead?: () => void;
  onNotificationSettings?: () => void;
};

export const MobileNotificationsHeader = ({
  onClose,
  onMarkAllAsRead,
  onNotificationSettings,
}: MobileNotificationHeaderProps) => {
  const [isActionSheetOpen, setIsActionSheetOpen] = useState(false);

  return (
    <header className="relative flex h-14 shrink-0 items-center justify-between border-b ads:border-b-ads-gray-5 border-b-gray-5 px-4">
      <div className="font-semibold ads:text-primary text-16 text-gray-12">Notifications</div>

      <div className="flex gap-2">
        <IconButton
          adsIcon
          appearance="ghost"
          color="gray"
          label="Notification settings"
          icon={EllipsisVerticalIcon}
          // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
          onClick={() => setIsActionSheetOpen(true)}
        />
        <IconButton adsIcon appearance="ghost" color="gray" label="Close" icon={XIcon} onClick={onClose} />
        {isActionSheetOpen && (
          // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
          <ActionSheet onClose={() => setIsActionSheetOpen(false)}>
            {/* biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration */}
            <ActionSheetHeader onClose={() => setIsActionSheetOpen(false)}>Notification settings</ActionSheetHeader>
            {renderActionSheetItems({
              options: [
                {
                  id: 'notification-settings',
                  label: 'Notification settings',
                  prefix: <SettingsIcon size="sm" />,
                  onSelect: onNotificationSettings,
                  type: 'item',
                },
                {
                  id: 'mark-all-as-read',
                  label: 'Mark all as read',
                  prefix: <CheckIcon size="sm" />,
                  onSelect: onMarkAllAsRead,
                  type: 'item',
                },
              ],
            })}
          </ActionSheet>
        )}
      </div>
    </header>
  );
};
